import React from 'react';
import { Box, Paper, Skeleton } from '@mui/material';

const MediaItemLoading: React.FC = () => (
  <Box sx={{ boxShadow: '0px 8px 60px #00000005' }}>
    <Skeleton
      variant="rectangular"
      height={125}
      sx={{
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px',
      }}
    />

    <Paper sx={{ p: 4, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
      <Skeleton />
      <Skeleton width={80} />
      <Skeleton width={30} />
    </Paper>
  </Box>
);

export default MediaItemLoading;
